import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './useDeadlineValidationErrors.translations.json';
import { GetApiErrorMessage } from '../common/utils/ValidationMessagesMap';
import { formatDate } from '../common/utils';
import { useMutationErrors } from '../common/queryClient';
import { ApiError } from '../common/ApiClient';

const { addTranslations, t } = i18nNsFactory('deadline-validation');
addTranslations(translations);

export const useDeadlineValidationErrors = () => {
  const {
    mutationErrors: deadlineValidationErrors,
    setMutationErrors: setDeadlineValidationErrors,
  } = useMutationErrors(
    translateDeadlineValidationError,
    groupDeadlineValidationErrors
  );

  return {
    deadlineValidationErrors,
    setDeadlineValidationErrors,
    displayDeadlineValidationType,
  };
};

const translateDeadlineValidationError: GetApiErrorMessage = (code, meta) => {
  const args = meta?.args as Record<string, string>;
  return t('alert.error.code.' + code, {
    code: args?.code,
    name: args?.name,
    heading: args?.outputType
      ? t('outputTypeCode.' + args.outputType) + ' '
      : '',
    valueDate: formatDate(args?.valueDate),
    dueDate: formatDate(args?.dueDate),
    childCode: args?.childCode,
    childName: args?.childName,
    childOutputType: t('outputTypeCode.' + args?.childOutputType),
    childValueDate: formatDate(args?.childValueDate),
    childDueDate: formatDate(args?.childDueDate),
  });
};

const displayDeadlineValidationType = (name: string) =>
  t('deadlineValidationTypeCode.' + name.split('__')[0]);

const groupDeadlineValidationErrors = (error: ApiError, i: number) => {
  return error.code + '__' + i;
};
